function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import isPlainObject from 'isobject';
import { assignStyle } from 'css-in-js-utils';

function hoverMediaPlugin(style) {
  for (var property in style) {
    var value = style[property];

    if (isPlainObject(value)) {
      var resolvedValue = hoverMediaPlugin(value);

      if (property === ':hover' || property === '&:hover') {
        style['@media (hover: hover)'] = _defineProperty({}, property, resolvedValue); // Remove the old hover style

        delete style[property];
      } else {
        style[property] = resolvedValue;
      }
    }
  }

  return style;
}

export default function hoverMedia() {
  return hoverMediaPlugin;
}